import React from 'react';
import { X, Trash2, Music, Play, PauseCircle } from 'lucide-react';
import { useAudioPlayer } from '../context/AudioPlayerContext';
import './QueuePanel.css';

const QueuePanel: React.FC = () => {
  const {
    state,
    removeFromQueue,
    clearQueue,
    playAudio,
    toggleQueue
  } = useAudioPlayer();
  const { queue, currentAudio, isQueueOpen } = state;

  const handlePlayFromQueue = (audio: typeof queue[0], queueIndex: number) => {
    // Play the selected audio and keep the rest of the queue intact
    // Move the queue index to track which one is playing
    playAudio(audio, queue, 'queue');
  };

  const handlePlayQueue = () => {
    // Start playing from the first item in the queue
    if (queue.length > 0) {
      const firstAudio = queue[0];
      playAudio(firstAudio, queue, 'queue');
    }
  };

  if (!isQueueOpen) return null;

  // Find the index of currently playing audio in the queue
  const currentPlayingIndex = currentAudio ? queue.findIndex(item => item.id === currentAudio.id) : -1;

  return (
    <div className="queue-panel-overlay" onClick={toggleQueue}>
      <div className="queue-panel simplified" onClick={(e) => e.stopPropagation()}>
        <div className="queue-header">
          <h3>
            <Music size={20} />
            Queue ({queue.length})
          </h3>
          <div className="queue-header-actions">
            {queue.length > 0 && (
              <>
                <button
                  className="play-queue-btn"
                  onClick={handlePlayQueue}
                  title="Play Queue"
                >
                  <Play size={18} />
                  <span>Play All</span>
                </button>
                <button
                  className="clear-queue-btn"
                  onClick={clearQueue}
                  title="Clear Queue"
                >
                  <Trash2 size={18} />
                </button>
              </>
            )}
            <button className="close-btn" onClick={toggleQueue}>
              <X size={20} />
            </button>
          </div>
        </div>

        <div className="queue-content">
          {queue.length === 0 ? (
            <div className="empty-queue">
              <Music size={48} />
              <p>No tracks in queue</p>
              <span>Add Naats while browsing to build your queue</span>
            </div>
          ) : (
            <div className="queue-list">
              {queue.map((audio, index) => (
                <div
                  key={`${audio.id}-${index}`}
                  className={`queue-item ${currentPlayingIndex === index ? 'playing' : ''}`}
                  onClick={() => handlePlayFromQueue(audio, index)}
                >
                  <div className="queue-item-number">
                    {currentPlayingIndex === index ? (
                      state.isPlaying ? (
                        <div className="playing-indicator">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      ) : (
                        <PauseCircle size={20} className="pause-indicator" />
                      )
                    ) : (
                      <span>{index + 1}</span>
                    )}
                  </div>
                  <div className="queue-item-info">
                    <span className="queue-item-title">{audio.title}</span>
                    {audio.urduTitle && (
                      <span className="queue-item-urdu" dir="rtl">{audio.urduTitle}</span>
                    )}
                    <span className="queue-item-artist">{audio.naatKhawan?.name}</span>
                  </div>
                  <button
                    className="remove-item-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      removeFromQueue(index);
                    }}
                    title="Remove from queue"
                  >
                    <X size={16} />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QueuePanel;